export function computeStylePermission(
  isToday: boolean,
  isLoadingGpsData: boolean,
  deviceIds?: string[],
) {
  if (isLoadingGpsData) return 'disabledLoadingGpsData'
  if (!deviceIds || deviceIds.length === 0) return 'disabledNoDevice'
  if (!isToday) return 'disabled'

  return 'enabled'
}
